(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/competition-handler/client/logger.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/competition-handler/client/logger.js');
'use strict';

const {
  LOGGER_NAME
} = svs.components.marketplaceCompetition.competitionHandler.common.constants;
const {
  log
} = svs.core;
const logger = log.getLogger(LOGGER_NAME);
setGlobal('svs.components.marketplaceCompetition.competitionHandler.client.logger', logger);

 })(window);